import React from 'react';
import { Badge } from '@/components/ui';
import { getStatusConfig } from '@/utils/status';

interface BoqStatusBadgeProps {
  status: string;
  className?: string;
}

export function BoqStatusBadge({ status, className = '' }: BoqStatusBadgeProps) {
  const config = getStatusConfig(status, {
    draft: { label: 'Bản thảo', variant: 'default', icon: 'ri-draft-line' },
    reviewing: { label: 'Đang soát xét', variant: 'info', icon: 'ri-search-eye-line' },
    approved: { label: 'Đã duyệt', variant: 'success', icon: 'ri-checkbox-circle-line' },
    locked: { label: 'Đã khóa', variant: 'secondary', icon: 'ri-lock-line' },
    revised: { label: 'Đã điều chỉnh', variant: 'warning', icon: 'ri-edit-box-line' },
    cancelled: { label: 'Đã hủy', variant: 'danger', icon: 'ri-close-circle-line' },
  });

  return (
    <Badge
      variant={config.variant as any}
      className={`text-[10px] font-bold  tracking-tight ${className}`}
    >
      {config.label}
    </Badge>
  );
}
